export default __webpack_public_path__ + "static/media/OM.4e734820.svg";